import {EventBus} from '@/event-bus'

function extractValueBetweenParentheses(str) {
  const match = str.match(/\(([^)]+)\)/);

  return match ? match[1] : null;
}

function isFrenchSiret(siret) {
  const frenchSiretPattern = /^\d{14}$/;

  return frenchSiretPattern.test(siret);
}

let store = {
  debug: true,
  state: {
    successMsg: [],
    warningMsg: [],
    errorMsg: [],
    infoMsg: []
  },
  pushSuccess(successMsg) {
    this.pushToMsgArray(successMsg, this.state.successMsg);
    this.emitToAlertComponent('success');
  },
  pushWarning(warningMsg) {
    this.pushToMsgArray(warningMsg, this.state.warningMsg);
    this.emitToAlertComponent('warning');
  },
  pushInfo(infoMsg) {
    this.pushToMsgArray(infoMsg, this.state.infoMsg);
    this.emitToAlertComponent('info')
  },
  pushError(errorMsg) {
    if (!errorMsg) {
      errorMsg = `Une erreur technique s'est produite, veuillez réessayer ultérieurement`;
    }

    const siret = extractValueBetweenParentheses(errorMsg);
    if (siret !== null && (typeof siret === 'string' || siret.length > 0)) {
      if (!isFrenchSiret(siret)) {
        return;
      }
    }

    this.pushToMsgArray(errorMsg, this.state.errorMsg);
    this.emitToAlertComponent('error');
  },
  pushToMsgArray(msg, array) {
    if (array.indexOf(msg) === -1) {
      array.push(msg);
    }
  },
  emitToAlertComponent(alertType) {
    EventBus.$emit('AlertComponent-push', alertType);
  },
  clearMsg(clearType) {
    EventBus.$emit('AlertComponent-clear', clearType);
  }
};

export default store;
